exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-small[data-v-65c4e7d6]{max-width:unset;max-height:80vh;overflow-y:scroll}.fail[data-v-65c4e7d6]{color:red}.success[data-v-65c4e7d6]{color:green}", ""]);

// exports
